export default (store, key) => {

    store.commit('setWorkflowKey', key);
    const workflows = store.ng.injector.get('Workflows').getWorkflows(key)

    _.each(workflows, workflow => {
        if(!_.isUndefined(workflow.storeAccessor) && _.isFunction(workflow.storeAccessor) && !workflow.storeAccessor(store)) {
            return;
        }
        store.commit('addAction', workflow);
    });
    store.dispatch('publishHighlightActions');
}



// WEBPACK FOOTER //
// ./src/app/store/base/actions/load-workflows.js